import { button } from "../Button/button.style";
import { AnchorComponentProps } from "./anchor.props";

export const Anchor = ({
    ref: anchorRef,
    children,
    className,
    size,
    color,
    outline,
    fullWidth,
    loading = false,
    test,
    tabIndex,
    dataAttributes,
    ...anchorHtmlAttributes
}: AnchorComponentProps) => {
    return (
        <a
            {...anchorHtmlAttributes}
            {...dataAttributes}
            data-test={test}
            className={button({
                size,
                color,
                outline,
                fullWidth,
                loading,
                className
            })}
            ref={anchorRef}
            tabIndex={tabIndex}
        >
            {children}
        </a>
    );
};
